import { IJSONStorage } from '@cp/shared/storage';

export class UserStorage<T> {
  protected storage: IJSONStorage<T>;

  constructor(storage: IJSONStorage<T>) {
    this.storage = storage;
  }

  protected setUserStorage(storage: Partial<T>) {
    const prevStorage = this.storage.getItem();
    this.storage.setItem({ ...prevStorage, ...(storage as T) });
  }
}
